<template>
  <table>
    <tbody>
      <tr>
        <td v-if="pricingMethod !== 2 && personsIncluded">
          <translate :tt="{ personsCount: persons }">
            Additional persons: {personsCount}
          </translate>
          <slot />
        </td>
        <td v-else>
          <slot />
        </td>
        <td>
          <pu-price :price="personsPrice" :display-original-price="true" />
          <translate class="per-stay"> per stay </translate>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { SimpleMoney } from '~/utility/money'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Persons extends Vue {
  @Prop()
  persons: number

  @Prop()
  personsPrice: SimpleMoney

  @Prop()
  pricingMethod: number

  @Prop()
  personsIncluded: number

  @Prop()
  pitchtypeCapacity: number

  @Prop()
  partySize: number

  @Prop()
  campsiteSlug: string

  @Prop()
  pitchtypeId: string
}

export default toNative(Persons)
</script>
<style scoped>
table {
  margin-top: 0.2em;
}

table td {
  padding: 0;
}

table tr {
  border: none;
}
</style>
